export default "__VITE_ASSET__C1vtF3Fa__"